import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { AuthState } from '@/store/auth/types';
import actions from './actions'
import mutations from './mutations'

const Auth: Module<AuthState, RootState> = {
  state: {
    token: null,
    profile: null,
  },
  actions,
  mutations,
};

export default Auth;
